import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import TitleSection from '../../components/layout/TitleSection';
import { ActualityAggregationField } from '../store/actuality.kpi.types';
import ActualityAggregateByGroupSelector from './ActualityAggregateByGroupSelector';
import FeedProcessPie from './FeedProcessPie';

interface FeedAggregatedPieChartProps {
  defaultAggregateBy?: ActualityAggregationField;
  showAggregationControl?: boolean;
  title?: string;
}

const FeedAggregatedPieChart: React.FC<FeedAggregatedPieChartProps> = ({
  defaultAggregateBy = 'eventProcessType',
  showAggregationControl = true,
  title,
}) => {
  const { t } = useTranslation('feed');
  const [aggregateBy, setAggregateBy] =
    useState<ActualityAggregationField>(defaultAggregateBy);
  const [selectedGroups, setSelectedGroups] = useState([]);

  console.log('FeedAggregatedPieChart  aggregateBy', aggregateBy);

  if (!showAggregationControl) {
    return <FeedProcessPie aggregateBy={defaultAggregateBy} title={title} />;
  }

  return (
    <TitleSection
      data-component="feed-aggregated-pie-chart"
      title={title}
      inPanelView
      className="!mt-4"
      isTransparent
    >
      {/* <PanelContainer
        id="panel-feed-aggregation-control"
        title={t`Aggregation Control`}
        collapsible
        hasPadding
      > */}
      {/* </PanelContainer> */}

      <FeedProcessPie
        aggregateBy={aggregateBy}
        // title={title}
        titleElement={
          <ActualityAggregateByGroupSelector
            // className="px-2 py-1"
            // title={t('Aggregate by')}
            value={aggregateBy}
            onChange={v => {
              setAggregateBy(v);
              setSelectedGroups([]);
            }}
          />
        }
      />
    </TitleSection>
  );
};

export default FeedAggregatedPieChart;
